import type { Enums } from "../types";

export const REGIONS: Array<Region> = [
	"BW",
	"BY",
	"BE",
	"BB",
	"HB",
	"HE",
	"HH",
	"MV",
	"NI",
	"NW",
	"RP",
	"SL",
	"SN",
	"ST",
	"SH",
	"TH",
] as const;

export type Region = Enums<"region">;
